var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('qx-custom-form',{ref:"baseForm",attrs:{"noSubBtn":true,"formData":_vm.formData},on:{"sub":_vm.sub}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }